import * as React from 'react';

import {FeatureUsageBox} from './feature-usage-box';

import styles from './feature-usage.module.css';

type Props = {
    currentUsage: number;
    currentPlanMaxUsage: number | null | undefined;
    hasCustomLimit: boolean;
    nextPlanMaxUsage: number | null | undefined;
    hasFurtherLimits?: boolean;
};

export function FeatureUsage(props: Props) {
    const {hasFurtherLimits = true} = props;

    return (
        <div className={styles['feature-usage']}>
            <FeatureUsageBox
                currentUsage={props.currentUsage}
                maxUsage={props.currentPlanMaxUsage}
                hasCustomLimit={props.hasCustomLimit}
                isCurrentPlan={true}
            />
            {hasFurtherLimits && (
                <FeatureUsageBox
                    currentUsage={props.currentUsage}
                    maxUsage={props.nextPlanMaxUsage}
                    hasCustomLimit={props.hasCustomLimit}
                    isCurrentPlan={false}
                />
            )}
        </div>
    );
}
